import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { EfaactDataService } from '../../efaact.data-service';
import { PtoPolicyAssignment } from './pto-policy-assignment.model';

export const entityName = 'PTOPolicyEmp';

@Injectable()
export class PtoPolicyAssignmentDataService extends EfaactDataService<PtoPolicyAssignment> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }

    // getById(id: string | number): Observable<PtoPolicyAssignment> {
    //     this.log.verbose({
    //         type: `${entityName}DataService(PolicyAssignmentDataService):getById`,
    //         id
    //     });
    //     return this.http
    //         .post<PtoPolicyAssignment>(this.entitiesUrl, { Policyid: id })
    //         .pipe(
    //             map(item => this.mapItems(item)),
    //             catchError((e, c) =>
    //                 fromShared.Errors.handleDataServiceError(this.store, e, c)
    //             )
    //         );
    // }

    mapItems(item: PtoPolicyAssignment): PtoPolicyAssignment {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.EmployeeListID,
            // FeeRetainPercentStartDate: moment(item.FeeRetainPercentStartDate).isValid() ? moment(item.FeeRetainPercentStartDate).toDate() : null,
            EffectiveDate: moment(item.EffectiveDate).isValid()
                ? moment(item.EffectiveDate).toDate()
                : null,
            AdjustedServiceDate: moment(item.AdjustedServiceDate).isValid()
                ? moment(item.AdjustedServiceDate).toDate()
                : null
        };
    }
}
